export default __webpack_public_path__ + "stat-sessions.473d69bb.svg";